module.exports = __webpack_public_path__ + "static/media/HappyShark.96aca1dc.png";